import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "my-4" }

import { ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import SystemService from "../../services/SystemService";
import MsgPrompt from "@/core/plugins/MsgPrompt";

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfigDetail',
  emits: ["submitted"],
  setup(__props, { expose: __expose, emit }) {

const isLoading = ref(false);
const modalRef = ref<InstanceType<typeof SimpleForm>>();
const category = ref("");
const rowId = ref(0);
const key = ref("");
const data = ref(<any>[]);
const value = ref<any>("");
const title = ref("");

const fecthData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.queryConfigByKey(
      category.value,
      rowId.value,
      key.value
    );
    data.value = res;

    if (data.value) {
      data.value["valueString"] = JSON.stringify(res.value);
      title.value = data.value.name;
      value.value = data.value.valueString;
    }
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

const hide = () => {
  modalRef.value?.hide();
};

const show = async (
  _category: string,
  _rowId: number,
  _key: string,
  _data?: string
) => {
  // category.value = capitalizeFirstLetter(_category);
  category.value = _category;
  rowId.value = _rowId;
  key.value = _key;

  await fecthData();

  if (data.value === null || data.value === undefined || data.value === "") {
    data.value = _data;
    title.value = data.value.name;
    value.value = data.value.valueString;
  }
  modalRef.value?.show();
};

const submit = async () => {
  try {
    await SystemService.updateConfigByKey(
      category.value,
      rowId.value,
      key.value,
      {
        value: JSON.parse(value.value),
        key: data.value.key,
        name: data.value.name,
        description: data.value.description,
        dataFormat: data.value.dataFormat,
      }
    )
      .then(() => {
        MsgPrompt.success("Update successfully");
      })
      .then(() => {
        emit("submitted");
        hide();
      });
  } catch (e) {
    console.log(e);
  }
};

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: title.value,
    "is-loading": isLoading.value,
    submit: submit,
    "before-close": hide,
    width: 900
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form_item, {
          label: "Value",
          "label-position": "right",
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              label: "value",
              modelValue: value.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
              autosize: { minRows: 1, maxRows: 6 },
              type: "textarea"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Description",
          "label-position": "right",
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: data.value.description,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.description) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})